// src/services/announcements.ts
import api, { webApi, getCsrfToken } from "../api";

// Public API (read-only) - uses API routes
export async function getAnnouncements() {
  return api.get("/announcements");
}

export function getAnnouncement(id: string | number) {
  return api.get(`/announcements/${id}`);
}

// Admin actions use web routes under /admin and require CSRF + session auth
export async function createAnnouncement(payload: {
  title: string;
  body: string;
}) {
  await getCsrfToken();
  return webApi.post(`/admin/announcements`, payload);
}

export async function updateAnnouncement(
  id: string | number,
  payload: { title: string; body: string }
) {
  await getCsrfToken();
  try {
    // include id in the body so defensive server handlers can locate the record
    // even if the request is routed to the collection endpoint by mistake
    return await webApi.put(`/admin/announcements/${id}`, { id, ...payload });
  } catch (err: any) {
    // Defensive fallback: some clients/hosts may reject PUT to the resource URL;
    // retry by sending id in body to the collection endpoint (server supports it).
    if (err?.response?.status === 405 || err?.response?.status === 404) {
      // First try sending id as query param
      try {
        return await webApi.put(`/admin/announcements?id=${id}`, payload);
      } catch (e: any) {
        // Fallback to sending id in body
        return webApi.put(`/admin/announcements`, { id, ...payload });
      }
    }
    throw err;
  }
}

export async function deleteAnnouncement(id: string | number) {
  await getCsrfToken();
  return webApi.delete(`/admin/announcements/${id}`);
}
